// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__XKyZv","tooltiptext":"Tooltip_tooltiptext__C+X3n"};